<template>
    <section class="my-5 mx-5">
        <link
            rel="stylesheet"
            href="https://cdnjs.cloudflare.com/ajax/libs/normalize/8.0.1/normalize.css"
        />
        <link
            rel="stylesheet"
            href="https://stackpath.bootstrapcdn.com/bootstrap/4.3.1/css/bootstrap.min.css"
            integrity="sha384-ggOyR0iXCbMQv3Xipma34MD+dH/1fQ784/j6cY/iJTQUOhcWr7x9JvoRxT2MZw1T"
            crossorigin="anonymous"
        />
        <section class="d-flex justify-content-between mb-3">
            <section class="col-6">
                <div class="row d-flex pb-0">
                    <p class="col-3">NO. NOTA  </p>
                    <p class="col-9">: {{ data.invoice }}</p>
                </div>
                <div class="row d-flex">
                    <p class="col-3">KETERANGAN  </p>
                    <p class="col-9">: {{ data.tipe_pembayaran }}</p>
                </div>
            </section>
            <div class="col-6 justify-content-end">
                <div class="row d-flex pb-0 font-weight-bold">
                    <p class="col-6">TUAN/NAMA TOKO  </p>
                    <p class="col-6">: {{ data.nama_toko }}</p>
                </div>
                <div class="row d-flex">
                    <p >{{ data.alamat_toko }}</p>
                </div>
            </div>
        </section>

        <section>
            <table class="table-border" style="width: 100%">
                <thead class="text-center">
                    <tr>
                        <th style="width: 12%;">BANYAKNYA</th>
                        <th>NAMA BARANG</th>
                        <th style="width: 12%;">HARGA</th>
                        <th style="width: 12%;">DISKON</th>
                        <th>JUMLAH</th>
                    </tr>
                </thead>
                <tbody>
                    <tr v-for="item in data.detail_penjualan">
                        <td class="text-center">{{ item.qty }} {{ item.qty_pcs > 0 ? `/${item.qty_pcs}` : '' }} </td>
                        <td>{{ item.nama_barang }}</td>
                        <td class="text-right">{{ ribuan(item.harga_tax) }}</td>
                        <td class="text-right">{{ ribuan(item.discount_tax) }}</td>
                        <td class="text-right">{{ ribuan(item.subtotal_tax) }}</td>
                    </tr>   
                    <tr class="font-weight-bold">
                        <td class="text-center">{{ data.total_qty }} {{ data.total_pcs > 0 ? `/${data.total_pcs}` : '' }} </td>
                        <td></td>
                        <td class="text-right">TOTAL</td>
                        <td class="text-right">{{ ribuan(data.diskon_tax) }}</td>
                        <td class="text-right">{{ ribuan(data.grand_total) }}</td>
                    </tr>
                </tbody>
            </table>
        </section>
        
        <section class="mt-3">
            <section class="d-flex justify-content-between">
                <p>HORMAT KAMI, </p>
                <p>DITERIMA OLEH, </p>
            </section>
            <p class="pt-6 text-center">NOTE : COD (transfer) {{ rekening.nama_bank }} {{ rekening.nomor_rekening }} {{ rekening.nama_pemilik_rekening }} </p>
        </section>
    </section>
</template>
<script>
import helper from "@/assets/js/helper.js";
export default {
    name: "PrintInvoiceObor",   
    mixins: [helper],
    data() {
        return {
            data: {},
            rekening: {},
        };
    },

    methods:{
        getData(){
            this.data = JSON.parse(localStorage.invoiceObor).data
            document.title = "INVOICE OBOR " + this.data.invoice + " - PRINT";
            this.rekening = this.data.rekenings[0];
            setTimeout(() => {
                window.print();
            }, 1000);
        },
    },
    mounted() {
        this.getData();
    },
}
</script>

<style lang="scss" scoped>
    p{
        margin-bottom: 5px;
        padding: 0;
    }
    .table-border {
        table-layout: fixed;
    }

    .table-border tr td {
        padding: 3px;
        border: solid 1px black;
    }

    .table-border tr th{
        padding: 5px;
        border: solid 1px black;
    }

    @media print {
        .table-border {
            border: solid 1px black !important;
        }
        .bottom {
            border-bottom: solid 1px black !important;
        }
        .content {
            margin: 5px;
        }
    }
</style>

